<ng-container [ngSwitch]="layout">
  <!-- Alternativerly use the main layout as the default switch case -->
    <sdc-main-layout *ngSwitchCase="Layouts.Main"></sdc-main-layout>
    <sdc-footer-only-layout *ngSwitchCase="Layouts.FooterOnly"></sdc-footer-only-layout>
</ng-container>
<!--<sdc-main-layout></sdc-main-layout>
<sdc-footer-only-layout></sdc-footer-only-layout>-->